// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__228JA","actions":"GroupTable_actions__2xp2F","deleteModalFooter":"GroupTable_deleteModalFooter__td3JX"};